<template>
  <v-card>
    <v-card-title>読み込み設定</v-card-title>
    <v-card-text>
      <p>
        CSV対応列は1から始まります。主キーを複数選択した場合は複合主キーになります。※現在、複合主キー未対応
      </p>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="4">
              <v-radio-group label="特殊関数の使用" v-model="rules[0]" row>
                <v-radio label="無" value="false"></v-radio>
                <v-radio label="有" value="true"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6" v-if="rules[0] != 'false'">
              <v-text-field
                label="メソッド名"
                outlined
                v-model="rules[1]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="rules[0] == 'false'">
            <div v-for="(v, i) in value" :key="i" class="mb-4">
              <v-col cols="12">
                <v-text-field
                  class="d-inline"
                  label="名前"
                  v-model="v.Label"
                  required
                  disabled
                ></v-text-field>
                <v-text-field
                  class="d-inline"
                  label="formID"
                  v-model.number="v.ID"
                  :rules="[varidation.numonly]"
                  required
                  disabled
                ></v-text-field>
                <v-text-field
                  class="d-inline"
                  label="CSV対応列"
                  v-model.number="v.csvCol"
                  :rules="[varidation.numonly]"
                  required
                ></v-text-field>
                <v-checkbox
                  v-model="v.primary"
                  :label="primaryLabel"
                ></v-checkbox>
              </v-col>
            </div>
          </v-row>
          <v-row algin="left" class="ma-2">
            <v-btn color="red white--text" @click="reset">reset</v-btn>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :color="returnData.color" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  props: {
    value: Array,
    page_id: Number,
    rule: Array,
  },
  data() {
    return {
      returnData: {
        value: this.value,
        page_id: this.page_id,
        rules: "",
      },
      //
      productForms: {
        //pageID: 0,
        area: [],
        //delete_area: [],
      },
      //
      values: [], //{ ID: 0, csvCol: 1, Label: "aa" },
      rules: [],
      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //変換
      if (this.rule.length > 0) {
        this.rules = this.rule;
      }
      //検索
      let data = {
        pageID: this.page_id,
        area: [this.productForms.area],
      };
      const response = await api.GetForm(data);
      console.log("response:", response.data);
      //変換
      let count = 0;
      let colCount = 1;
      for (let j = 0; j < response.data[0].length; j++) {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i][j].Type != 0) {
            //データが不足
            if (this.value[count] == null) {
              this.value.push({ csvCol: colCount });
              colCount++;
            }
            //データの差し替え
            if (
              this.value[count].ID != response.data[i][j].ID ||
              this.value[count].Label != response.data[i][j].Label
            ) {
              this.value[count].ID = response.data[i][j].ID;
              this.value[count].Label = response.data[i][j].Label;
            }
            ///完了
            count++;
          }
        }
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        var list = this.returnData.value.map(function(row) {
          return row["csvCol"];
        });
        if (Array.from(new Set(list)).length != this.returnData.value.length) {
          alert("列番号が重複しています");
          return;
        }
        //
        console.log("文字数:", JSON.stringify(this.value).length);

        this.returnData.rule = this.rules;
        this.returnData.value = this.value;
        this.$emit("clickSubmit", this.returnData);
      }
    },
    reset() {
      this.value = [];
    },
  },
  computed: {
    primaryLabel: function() {
      let count = 0;
      this.value.forEach((v) => {
        if (v.primary == true) {
          count++;
        }
      });
      if (count >= 2) {
        return "複合主キー";
      } else {
        return "主キー";
      }
    },
  },
};
</script>
